var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-word-cloud',{staticStyle:{"height":"calc(80vh)","width":"100%"},attrs:{"words":_vm.words,"color":function (ref) {
                var weight = ref[1];

                return weight > 10000 ? 'DeepPink' : weight > 5000 ? 'RoyalBlue' : 'Indigo';
},"font-family":"Roboto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }